<template>
    <v-container fluid class="pa-0">
        <v-toolbar color="grey-lighten-3">
            <v-toolbar-title class="text-h6 font-weight-medium">
                Web Chat Widget
            </v-toolbar-title>
        </v-toolbar>
        <div v-if="loading" class="pa-4">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        <div v-else-if="error" class="pa-4">
            <v-banner color="error" icon="$error" lines="one">
                <v-banner-text>{{ error }}</v-banner-text>
            </v-banner>
        </div>
        <div v-else class="pa-4">
            <v-banner class="mb-4" color="info" icon="$info" lines="two">
                <v-banner-text>
                    Paste this snippet into the client's website (before the closing
                    <code>&lt;/body&gt;</code> tag) to embed the "Contact Us" chat widget for
                    <strong>{{ clientName }}</strong>. Submissions are routed into the conversation
                    inbox automatically.
                </v-banner-text>
            </v-banner>

            <v-text-field
                v-model="src"
                label="Page/site label (optional)"
                hint="Identifies where a message came from if you embed this on multiple pages"
                persistent-hint
                variant="outlined"
                density="compact"
                class="mb-4"
                style="max-width: 420px"
                @change="refreshSnippet"
            />

            <v-card variant="outlined">
                <v-card-text>
                    <pre class="snippet">{{ snippet }}</pre>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="copySnippet">
                        <v-icon left class="mr-1">mdi-content-copy</v-icon>
                        {{ copied ? "Copied!" : "Copy Snippet" }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </v-container>
</template>

<script>
import MiscService from "@/services/miscService";

export default {
    name: "WebChatWidget",
    data() {
        return {
            loading: true,
            error: "",
            clientName: "",
            snippet: "",
            src: "",
            copied: false,
        };
    },
    methods: {
        async refreshSnippet() {
            try {
                this.loading = true;
                this.error = "";
                const res = await MiscService.getWidgetEmbedSnippet(this.src);
                this.clientName = res.data.client_name;
                this.snippet = res.data.snippet;
            } catch (error) {
                console.error("Failed to load widget embed snippet:", error);
                this.error = "Failed to load the widget embed snippet. Please try again.";
            } finally {
                this.loading = false;
            }
        },
        async copySnippet() {
            try {
                await navigator.clipboard.writeText(this.snippet);
                this.copied = true;
                setTimeout(() => (this.copied = false), 2000);
            } catch (error) {
                console.error("Failed to copy snippet:", error);
            }
        },
    },
    mounted() {
        this.refreshSnippet();
    },
};
</script>

<style scoped>
.snippet {
    white-space: pre-wrap;
    word-break: break-all;
    font-family: monospace;
    font-size: 13px;
    margin: 0;
}
</style>
